<template>
  <div
    class="swiper-picture"
    :style="`aspect-ratio: ${ratio}`"
    :class="{ 'is-landscape': ratio > 1, 'is-portrait': ratio < 1 }"
  >
    <img
      v-lazy="{
        src: baseUrl + picture.field_media_image,
      }"
    />
  </div>
</template>

<script>
export default {
  props: {
    picture: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    baseUrl: "",
  }),
  mounted() {
    this.baseUrl = process.env.VUE_APP_API_BASE_URL;
  },
  computed: {
    ratio() {
      return (this.picture.field_width / this.picture.field_height).toFixed(2);
    },
  },
};
</script>

<style lang="scss">
.swiper-picture {
  background: linear-gradient(
    90deg,
    rgba(#6d00cf, 1) 0%,
    rgba(#6d00cf, 0.6) 50%,
    rgba(#6d00cf, 1) 100%
  );
  background-size: 200% 100%;

  &.is-landscape {
    width: 100%;
    max-width: 1200px;
  }

  &.is-portrait {
    height: 100%;
    max-width: 100%;
  }

  img {
    width: 100%;
  }
  // animation: moveBackground 2s infinite linear;
}

@keyframes moveBackground {
  0% {
    background-position: 200% 0%;
  }
  100% {
    background-position: 0% 0%;
  }
}
</style>
